module.exports = __webpack_public_path__ + "img/QRM.fb2599ee.svg";